// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o5kV","selected":"styles_selected__1V1-P"};